<template>
  <div class="flex flex-wrap -mb-8 -mr-6 p-8">
    <info-label :title="$t('applicants.info_label_title_1')" :subtitle="$t('applicants.info_label_subtitle_1')"/>
    <text-input v-model="form.first_name" :error="form.errors.first_name" class="pb-8 pr-6 w-full lg:w-1/2"
                :label="$t('applicants.first_name')" :required="true"
    />
    <text-input v-model="form.last_name" :error="form.errors.last_name" class="pb-8 pr-6 w-full lg:w-1/2"
                :label="$t('applicants.last_name')" :required="true"
    />

    <text-input v-model="form.birth_place" :error="form.errors.birth_place" class="pb-8 pr-6 w-full lg:w-1/2"
                :label="$t('applicants.birth_place')"
    />
    <text-input
      :date-not-in-future="true"
      :min-year="1"
      type="date" v-model="form.date_birth" :error="form.errors.date_birth" class="pb-8 pr-6 w-full lg:w-1/2"
      :label="$t('applicants.date_birth')"
    />
    <select-dropdown v-model="form.nationality_id" :error="form.errors.nationality_id" class="pr-6 pb-8 w-full lg:w-1/3"
                     :options="nationalities" :label="$t('applicants.nationality')" sort-by="name"
    />
    <text-input
      v-model="form.national_registry"
      :error="form.errors.national_registry"
      v-maska="'##.##.##-###-##'"
      class="pb-8 pr-6 w-full lg:w-1/3"
      placeholder="e.g. 11.11.11-111-11"
      :label="$t('applicants.national_registry')"
    />
    <text-input v-model="form.email" :error="form.errors.email" type="email" class="pb-8 pr-6 w-full lg:w-1/3"
                :label="$t('applicants.email')"
    />
    <text-input v-model="form.residence_permit" :error="form.errors.residence_permit" class="pb-8 pr-6 w-full lg:w-1/2"
                :label="$t('applicants.residence_permit')"
    />
    <text-input v-model="form.income" :error="form.errors.income" class="pb-8 pr-6 w-full lg:w-1/2"
                :label="$t('applicants.income')"
    />
    <text-input v-model="form.mutuality" :error="form.errors.mutuality" class="pb-8 pr-6 w-full lg:w-1/2"
                :label="$t('applicants.mutuality')"
    />
    <text-input v-model="form.syndicate" :error="form.errors.syndicate" class="pb-8 pr-6 w-full lg:w-1/2"
                :label="$t('applicants.syndicate')"
    />
    <radio-horizontal v-model="form.gender_id" :error="form.errors.gender_id" class="pr-6 pb-8 w-full lg:w-1/3"
                      :options="genders" :label="$t('applicants.gender')" :required="true"
    />
    <radio-horizontal v-model="form.civil_state_id" :error="form.errors.civil_state_id"
                      class="pr-6 pb-8 w-full lg:w-2/3" :options="civil_states" :label="$t('applicants.civil_state')"
    />
    <info-label class="mt-5" :title="$t('applicants.info_label_title_2')"
                :subtitle="$t('applicants.info_label_subtitle_2')"
    />
    <select-tags v-model="form.phone" :error="form.errors.phone" class="pb-8 pr-6 w-full lg:w-1/2"
                 :label="$t('applicants.phone')" :placeholder="$t('applicants.placeholder.phone')"
    />
    <select-multiple :default-options="languages" v-model="form.language_ids" :error="form.errors.language_ids"
                     class="pb-8 pr-6 w-full lg:w-1/2" :label="$t('applicants.languages')" required
                     :placeholder="$t('applicants.placeholder.language')" :hint="$t('applicants.hint.languages')"
    />
    <text-input v-model="form.language_field" :error="form.errors.language_field" class="pb-8 pr-6 w-full lg:w-1/3"
                :label="$t('applicants.language_specify')" v-if="emptyLanguageField"
    />
    <text-input v-model="form.street" :error="form.errors.street" class="pb-8 pr-6 w-full lg:w-4/4"
                :label="$t('applicants.street')" :hint="$t('applicants.hint.street')"
    />
    <text-input v-model="form.street_number" :error="form.errors.street_number" class="pb-8 pr-6 w-full lg:w-1/4"
                :label="$t('applicants.street_number')"
    />
    <text-input v-model="form.zip_code" :error="form.errors.zip_code" class="pb-8 pr-6 w-full lg:w-1/4"
                :label="$t('applicants.zip_code')"
    />
    <text-input v-model="form.city" :error="form.errors.city" class="pb-8 pr-6 w-full lg:w-2/4"
                :label="$t('applicants.city')"
    />
    <textarea-input v-model="form.note" :error="form.errors.note" class="pb-8 pr-6 w-full lg:w-4/4"
                :label="$t('applicants.note')"
    />
    <checkbox
      v-model="form.closed" :error="form.errors.closed" class="pb-8 pr-6 w-full lg:w-1/2"
      :label="$t('applicants.closed.label')"
    />
  </div>
</template>
<script>
import TextInput from '@/Shared/TextInput'
import SelectDropdown from '@/Shared/SelectDropdown'
import RadioHorizontal from '@/Shared/RadioHorizontal'
import SelectTags from '@/Shared/SelectTags'
import SelectMultiple from '@/Shared/SelectMultiple'
import InfoLabel from '@/Shared/InfoLabel'
import intersectionWith from 'lodash/intersectionWith'
import Checkbox from '@/Shared/Checkbox'
import map from 'lodash/map'
import TextareaInput from '@/Shared/TextareaInput'

export default {
  components: {
    TextInput,
    RadioHorizontal,
    InfoLabel,
    SelectDropdown,
    SelectTags,
    SelectMultiple,
    TextareaInput,
    Checkbox
  },
  props: ['formData', 'genders', 'nationalities', 'civil_states', 'languages', 'locations'],
  computed: {
    form() {
      return this.formData
    },
    //If request has empty_field (e.g. other), show empty text field
    emptyLanguageField() {
      let content = intersectionWith(this.languages, map(this.form.language_ids, 'id'), (o, id) => o.id === id)
      for (let item of content) {
        if (item.empty_field) {
          return true
        }
      }
      return false
    },
  },
}
</script>
